import Header from "../component/header";
import Footer from "../component/footer";


import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useRef, useEffect } from 'react';
import VanillaTilt from 'vanilla-tilt';

import { useGSAP } from "@gsap/react";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all';
import Lenis from 'lenis'
import useGsapAnimations from '../component/useGsapAnimations';

gsap.registerPlugin(ScrollTrigger) 

function About() {

    useGsapAnimations()

     useEffect(() => {

      
    // /////// Blog Item 
    
    const blogItems = document.querySelectorAll(".blog__item-1");

    function followImageCursor(event, blogImgItem) {
      const contentBox = blogImgItem.getBoundingClientRect();
      const dx = event.clientX - contentBox.x;
      const dy = event.clientY - contentBox.y;
      const targetEl = blogImgItem.children[2]; // Make sure the 3rd child exists
      if (targetEl) {
        targetEl.style.transform = `translate(${dx}px, ${dy}px)`;
      }
    }

    blogItems.forEach((item) => {
      item.addEventListener("mousemove", (event) => followImageCursor(event, item));
    });

    // Cleanup
    return () => {
      blogItems.forEach((item) => {
        item.removeEventListener("mousemove", (event) => followImageCursor(event, item));
      });
    };
  }, []);
    
    const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

//
//  Vanilla-Tilt

// 
const tiltRefs = useRef([]);
const layoutRef = useRef(null);

useEffect(() => {
  // Store the current refs so cleanup uses the same elements
  const tiltElements = tiltRefs.current;
  const layoutElement = layoutRef.current;

  // Initialize VanillaTilt on multiple elements
  tiltElements.forEach((ref) => {
    if (ref) {
      VanillaTilt.init(ref, {
        max: 15,
        speed: 1000,
        scale: 1.03,
        glare: true,
        "max-glare": 0.2,
        fullPageListening: true,
      });
    }
  });

  // Initialize VanillaTilt on the layout element
  if (layoutElement) {
    VanillaTilt.init(layoutElement, {
      max: 15,
      speed: 1000,
      scale: 1.03,
      glare: true,
      "max-glare": 0.2,
      fullPageListening: true,
    });
  }

  // Cleanup
  return () => {
    tiltElements.forEach((ref) => {
      if (ref?.vanillaTilt) {
        ref.vanillaTilt.destroy();
      }
    });

    if (layoutElement?.vanillaTilt) {
      layoutElement.vanillaTilt.destroy();
    }
  };
}, []);


//   /////// 
// Gasp

      useGSAP(() => {
        gsap.to('.parallax-image', {
                y: '-30%', // Adjust the value to control the intensity of the parallax effect
                ease: 'none',
                scrollTrigger: {
                    trigger: '.parallax-container',
                    start: 'top bottom',
                    end: 'bottom top', // Adjust the scroll range to reduce padding at the bottom
                    scrub: 0.8 // Enables smooth scrolling effect
                }
            });
      })
    

    return (
<main>
   <Header/>


    <div id="smooth-wrapper">
        <div id="smooth-content">
            {/* <!-- Add your site or application content here --> */}
            <main>
                {/* <!-- about us area start  --> */}
                <div className="about-area section-spacing p-relative adjust-header-space">
                    <div className="container">
                          <div className=" area-absolute">
                        <img src="assets/img/bg/box-gradient-bg.jpg" alt="mystra-about"/>
                    </div>
                        <div className="about-us-2-wrapper p-relative">
                            
                            <div className="row">
                                <div className="col-xxl-12">
                                    {/* <div className="about-science-wrapper">
                                        <div className="area-btn">
                                            <a href="assets/video/team-session.mp4" className="circle-btn popup-video bdFadeUp">
                                                <span className="icon-box"
                                                    data-background="assets/img/gallery/gallery-16.jpg">
                                                    <svg width="23" height="26" viewBox="0 0 23 26" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M23 13L0.499999 25.9904L0.5 0.00961778L23 13Z"
                                                            fill="white" />
                                                    </svg>
                                                </span>
                                                <img src="assets/img/icons/play-btn-award.png" alt="mystra-about"
                                                    className="image-text"/>
                                            </a>
                                        </div>
                                    </div> */}
                                    <div className="about-us-thumb-grid p-relative">
                                          {["team-1.webp", "team-2.webp", "team-3.webp"].map((img, index) => (
                                            <div
                                                key={index}
                                                className={`bdFadeUp about-us-thumb-${index + 3}`}
                                                ref={(el) => (tiltRefs.current[index] = el)}
                                            >
                                                <img src={`assets/img/home/${img}`} alt="mystra-about" />
                                            </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xxl-7 col-xl-7 col-lg-8">
                                <div className="about-us-2-title">
                                    <div className="section__title-wrapper">
                                        {/* <span className="section__inner-subtitle">About us</span> */}
                                        <h2 className="section__title-inner title-anim mb-25">Transforming Businesses, One Pixel at a Time.</h2>
                                    </div>
                                    <p className="p-text">At Mystra Technologies LLP, we're not just web developers – we're architects of digital dreams. With a combined industry experience of over 40 years, our management team has navigated the ever-changing tech landscape to bring you innovative solutions that propel your business forward.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- about us area end  --> */}


                          {/* <!-- choose area start  --> */}
                <section className="choose-area section-spacing">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                
                                <div className="choose-area-content">
                                    <div className="section__title-3-wrapper ">
                                        <div className="section__subtitle-3">
                                            <p className="section__subtitle-text">
                                                What We Do
                                            </p>
                                            {/* <!-- <div className="section__subtitle-number"> */}
                                                {/* <span>03</span>
                                            </div> --> */}
                                        </div>
                                        <h2 className="section__title-main xlarge uppercase mb-0 bdFadeRight">Where Creativity Meets Technology
                                            <span className=" tpl__theme-color">We’re your one-stop digital powerhouse</span>
                                        </h2>
                                    </div>
                                    {/* <div className="thumb-wrapper mb-60 bdFadeUp">
                                        
                                        <span className="line"></span>
                                        <img src="assets/img/about/7-last-min.png" alt="mystra-about"/>
                                    </div> */}
                                    <p className="xlarge mb-65 bdFadeUp">We specialize in UX/UI design, app/web
                                    development, content production, digital
                                    marketing, and creating custom AI agents to
                                    streamline your corporate processes</p>
                                    <div className="choose-accordion mb-0 tp-accordion-fix">
                                        <div className="accordion" id="accordionExample-st-2">
                                            <div className="row g-5 bdFadeUp">
                                                <div className="col-lg-6">
                                                    <div className="accordion-item mb-30 bg-white">
                                                        <h2 className="accordion-header" id="headingOne-sts-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseOne-sts-2" aria-expanded="false"
                                                                aria-controls="collapseOne-sts-2">
                                                                Web Design & UI/UX Sorcery
                                                            </button>
                                                        </h2>
                                                        <div id="collapseOne-sts-2" className="accordion-collapse collapse"
                                                            aria-labelledby="headingOne-sts-2"
                                                            data-bs-parent="#accordionExample-sts-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>It’s not magic, but our results are enchanting. We practice the sorcery of custom web design and UI/UX, crafting responsive, user-centric websites with an intuitive UI. Our goal is to create a seamless user experience that captivates your audience on any device, boosting engagement and driving conversions.  </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                      <div className="accordion-item bg-white">
                                                        <h2 className="accordion-header" id="headingTwo-sts-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseTwo-sts-2" aria-expanded="false"
                                                                aria-controls="collapseTwo-sts-2">
                                                                Social Media Marketing and Strategy
                                                            </button>
                                                        </h2>
                                                        <div id="collapseTwo-sts-2" className="accordion-collapse collapse"
                                                            aria-labelledby="headingTwo-sts-2"
                                                            data-bs-parent="#accordionExample-sts-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>We practice social media alchemy, brewing the perfect strategy to elevate your online presence. Our service blends compelling content creation with proactive community management to grow your following. We run targeted social media marketing campaigns designed to boost engagement, build brand awareness, and conjure a loyal, thriving digital community.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                      <div className="accordion-item bg-white mb-30">
                                                        <h2 className="accordion-header" id="headingTwo-sts-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseTwo-sts-2" aria-expanded="false"
                                                                aria-controls="collapseTwo-sts-2">
                                                                SEO & SEM Dominance
                                                            </button>
                                                        </h2>
                                                        <div id="collapseTwo-sts-2" className="accordion-collapse collapse"
                                                            aria-labelledby="headingTwo-sts-2"
                                                            data-bs-parent="#accordionExample-sts-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>We perform the digital rites to achieve total search dominance. Through meticulous keyword research and powerful on-page SEO services, our incantations improve your search engine ranking. We then launch potent SEM campaigns to capture paid traffic, summoning a constant flow of qualified leads and ensuring your brand's lasting visibility </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item bg-white">
                                                        <h2 className="accordion-header" id="headingFour-sts-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseFour-sts-2"
                                                                aria-expanded="false" aria-controls="collapseFour-sts-2">
                                                                AI Revolution
                                                            </button>
                                                        </h2>
                                                        <div id="collapseFour-sts-2"
                                                            className="accordion-collapse collapse"
                                                            aria-labelledby="headingFour-sts-2"
                                                            data-bs-parent="#accordionExample-sts-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>Experience the future of corporate communication with AI chat agents. Our intelligent chatbots automate customer support, enhance user engagement, and drive productivity. Leverage AI-driven customer service, natural language processing, and conversational AI for 24/7 instant responses, lead generation, and seamless business operations. Transform corporate efficiency, boost satisfaction, and achieve search engine dominance with smart AI chat solutions</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- choose area end  --> */}


                {/* <!-- why area start --> */}
                <section className="why-area primary-bg section-spacing">
                    
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="section__title-wrapper is-white mb-60">
                                    {/* <span className="section__inner-subtitle">Why Choose Mystra?</span>\ */}
                                    <div className="section__subtitle-3"><p className="section__subtitle-text">Why Choose Mystra?</p></div>
                                    <h2 className="section__title-inner title-anim">
                                        We’re a <span className="tpl__theme-color">creative agency</span> based in <span className="tpl__theme-color">Bengaluru</span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="why-wrapper">
                                    {/* <div className="why-content">
                                        <div className="why-thumb" data-background="assets/img/gallery/gallery-29.jpg" style={{backgroundImage: "url(assets/img/gallery/gallery-29.jpg)"}}>
                                        </div>
                                        <div className="area__btn">
                                            <a id="player" href="assets/video/team-session.mp4"
                                                className="circle-btn popup-video">
                                                <span className="icon-box"
                                                    data-background="assets/img/gallery/gallery-1.jpg">
                                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M23.1646 13L0.66455 25.9904L0.664551 0.00961778L23.1646 13Z"
                                                            fill="white"></path>
                                                    </svg>
                                                </span>
                                                <img src="assets/img/icons/play-text-white.png" alt="mystra-about"
                                                    className="image-text"/>
                                            </a>
                                        </div>
                                        <span className="line"></span>
                                    </div> */}
                                    <p className="xlarge bdFadeUp">We specialize in UX/UI design, app/web development, content production, digital marketing, and creating custom AI agents to streamline your corporate processe</p>
                                    <div className="why-accordion tp-accordion-fix">
                                        <div className="accordion" id="accordionExample-st-2">
                                            <div className="row g-5 bdFadeUp">
                                                <div className="col-lg-6">
                                                    <div className="accordion-item mb-30">
                                                        <h2 className="accordion-header" id="headingOne-st-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseOne-st-2" aria-expanded="false"
                                                                aria-controls="collapseOne-st-2">
                                                                Partners, Not Vendors
                                                            </button>
                                                        </h2>
                                                        <div id="collapseOne-st-2" className="accordion-collapse collapse"
                                                            aria-labelledby="headingOne-st-2"
                                                            data-bs-parent="#accordionExample-st-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>We see our clients as fellow adventurers on a shared quest, not just another name on a contract. We are partners, not vendors. This means we are deeply invested in your long-term success, embedding ourselves with your team to truly understand your goals and conjure a strategy that ensures we win, together.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item  mb-30">
                                                        <h2 className="accordion-header" id="headingTwo-st-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseTwo-st-2" aria-expanded="false"
                                                                aria-controls="collapseTwo-st-2">
                                                               Constant Evolution, Lasting Growth
                                                            </button>
                                                        </h2>
                                                        <div id="collapseTwo-st-2" className="accordion-collapse collapse"
                                                            aria-labelledby="headingTwo-st-2"
                                                            data-bs-parent="#accordionExample-st-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>We believe in leading, not just adapting. The digital world is always evolving, and we are committed to being at the forefront of that change. Our passion for pioneering new technologies and strategies ensures your brand is always positioned ahead of the curve, setting trends rather than following them.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="accordion-item mb-30">
                                                        <h2 className="accordion-header" id="headingThree-st-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseThree-st-2"
                                                                aria-expanded="false"
                                                                aria-controls="collapseThree-st-2">
                                                                The minds behind the Magic
                                                            </button>
                                                        </h2>
                                                        <div id="collapseThree-st-2" className="accordion-collapse collapse"
                                                            aria-labelledby="headingThree-st-2"
                                                            data-bs-parent="#accordionExample-st-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>A fusion of experience and audacity, our team marries decades of industry grit with Gen-Z’s hunger for disruption. From caffeine-fueled brainstorming in our Koramangala hub to late-night sprints, we share one driving purpose: transforming challenges into achievements and redefining what’s possible for our clients.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header" id="headingSix-st-2">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseSix-st-2"
                                                                aria-expanded="false" aria-controls="collapseSix-st-2">
                                                               Empowerment over Dependency
                                                            </button>
                                                        </h2>
                                                        <div id="collapseSix-st-2"
                                                            className="accordion-collapse collapse"
                                                            aria-labelledby="headingSix-st-2"
                                                            data-bs-parent="#accordionExample-st-2">
                                                            <div className="accordion-body">
                                                                <div className="capabilities-list">
                                                                    <div className="choose-accordion-content">
                                                                        <p>We don’t just solve problems; we hand you the wand. Mystra’s mission is to unleash your potential, arming you with the knowledge and technology to lead. Break free from perpetual guidance—our solutions empower your team to master the digital realm, forging success that stands tall and endures</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- why area end --> */}


                  {/* <!-- services area start  --> */}
                  <section className="services-area-3 fix" id="services-area-3">
                    <div className="services-area-3__bg area-absolute">
                        <img src="assets/img/bg/noise-2.png" alt="mystra-about"/>
                    </div>
                    <div className="area-shapes">
                        <img className="services-area-3__shape-1" src="assets/img/shapes/border-square.png"
                            alt="mystra-about"/>
                        <img className="services-area-3__shape-2" src="assets/img/shapes/circle-line.png"
                            alt="mystra-about"/>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-5 order-lg-2">
                                <div className="services-area-3-content section-spacing p-relative">
                                    <div className="section__title-3-wrapper section__title-wrapper-services ">
                                        <div className="section__subtitle-3">
                                            <p className="section__subtitle-text">
                                                Our Promise
                                            </p>
                                            {/* <!-- <div className="section__subtitle-number"> */}
                                                {/* <span>02</span>
                                            </div> --> */}
                                        </div>
                                        <h2 className="section__title-main uppercase mb-45 title-anim">Build Smarter. Scale Faster.<br/>
                                            <span className="tpl__theme-color">Future-Proof Everything.</span>
                                        </h2>
                                    </div>
                                    <p className="mb-65">

We transform businesses by integrating
cutting-edge technology with compelling
creative work</p>
                                    <div className="area-btn btn_wrapper">
                                        <a className="c-button btn-moving" href="/mystra-service" >
                                            <span className="c-button__border"></span>
                                            <span className="c-button__text">View All Services</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-7 order-lg-1">
                                <div className="services-wrapper-3 section-spacing p-relative">
                                    <div className="services-wrapper-3__bg area-absolute bg-theme-3">
                                    </div>
                                    <div className="row g-5 bdFadeUp">
                                        <div className="col-xl-12">
                                            <div className="service-box-3 bd-one-by-one">
                                                <div className="service-box-3__content">
                                                    <h4 className="service__title">
                                                        <a href="/mystra-service">Dominate SEO</a>
                                                    </h4>
                                                    <p>Own Google’s top results, forever.</p>
                                                    {/* <!-- <div className="area-btn">
                                                        <a href="/mystra-service" className="text-btn btn-text">View
                                                            Details</a>
                                                    </div> --> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12">
                                            <div className="service-box-3 bd-one-by-one">
                                                <div className="service-box-3__content">
                                                    <h4 className="service__title">
                                                        <a href="/mystra-service">Scale Seamlessly</a>
                                                    </h4>
                                                    <p>Handle 10 users or 10 million without breaking a sweat.</p>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12">
                                            <div className="service-box-3 bd-one-by-one">
                                                <div className="service-box-3__content">
                                                    <h4 className="service__title">
                                                        <a href="/mystra-service">Out-Innovate Tomorrow </a>
                                                    </h4>
                                                    <p> Ready for AI, metaverse, or whatever’s next.</p>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* <!-- services area end  --> */}


                    {/* <!-- testimonial area start  --> */}
                <section className="testimonial-3-area primary-bg section-spacing p-relative bottom-curve">
                    <div className="area-shapes bdFadeUp">
                        <img className="testimonial-round" src="assets/img/shapes/circle-line.png" alt="mystra-about"/>
                    </div>
                    <div className="container">
                        <div className="row align-items-end mb-55">
                            <div className="col-xxl-12">
                                <div className="section__title-3-wrapper section__title-wrapper-team">
                                    <div className="section__subtitle-3">
                                        <p className="section__subtitle-text">
                                            Testimonial
                                        </p>
                                       
                                    </div>
                                    <h2 className="section__title-main xlarge uppercase title-anim">100% <span
                                            className="font-highlight tpl__theme-color">Satisfied customers</span> 
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-wrapper-3 p-relative nav-on-hover">
                            <div className="swiper-container testimonial-slider-2">
                                <div className="swiper-wrapper bdFadeUp">
                                    <Swiper
                                        modules={[Navigation, Autoplay]}
                                        autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        }}
                                        loop={true}
                                        slidesPerView={1}
                                        navigation={{
                                        nextEl: '.brand-2-button-next',
                                        prevEl: '.brand-2-button-prev',
                                        }}
                                        breakpoints={{
                                        640: { slidesPerView: 1 },
                                        768: { slidesPerView: 2, spaceBetween: 15 },
                                        1024: { slidesPerView: 3, spaceBetween: 20 },
                                        }}
                                        scrollbar={{ draggable: true }}
                                        onSwiper={(swiper) => console.log(swiper)}
                                        onSlideChange={() => console.log('slide change')}
                                    >
                                     <SwiperSlide>
                                     <div className="swiper-slide">
                                        <div className="testimonial-box-2">
                                            <h4>Digital Marketing Project</h4>
                                            <div className="quote-icon">
                                                <svg viewBox="0 0 83 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M20.8162 27.6795C21.5404 22.1887 26.3942 17.2186 35.2725 12.8877L36.8713 12.1077L30.3167 0.00634766L28.837 0.756361C10.0619 10.2736 0.541992 23.7238 0.541992 40.7336C0.541992 46.6026 2.40503 51.6715 6.07972 55.7999C9.80594 59.9858 14.3279 62.1083 19.521 62.1083C24.1871 62.1083 28.1438 60.4467 31.2811 57.1692C34.3979 53.9127 35.9783 49.8679 35.9783 45.1469C35.9783 40.6858 34.3819 36.7101 31.2336 33.3303C28.4567 30.3491 24.9577 28.4527 20.8162 27.6795ZM28.8176 54.8112C26.3139 57.4268 23.273 58.6982 19.521 58.6982C15.2846 58.6982 11.7212 57.0084 8.62721 53.5325C5.48125 49.9984 3.95192 45.8119 3.95192 40.7335C3.95192 32.9375 6.1472 25.8991 10.4764 19.8141C14.6072 14.0084 20.8028 8.88265 28.907 4.56263L32.1907 10.6249C22.3151 15.8001 17.3114 22.0212 17.3114 29.1335V30.6564L18.8245 30.8277C22.9003 31.2891 26.1428 32.8679 28.7384 35.6544C31.3154 38.4209 32.5682 41.5262 32.5682 45.1467C32.5683 49.0132 31.3413 52.1743 28.8176 54.8112Z"
                                                        fill="#14CF93" />
                                                    <path
                                                        d="M67.0889 27.6836C67.8045 22.1883 72.6183 17.2157 81.4255 12.8842L82.9998 12.11L76.608 0L75.1136 0.754039C56.2526 10.2708 46.6895 23.7216 46.6895 40.7327C46.6895 46.6055 48.5763 51.6771 52.2974 55.8066C56.0649 59.9873 60.6055 62.1072 65.7944 62.1072C70.4663 62.1072 74.4048 60.4424 77.5004 57.1589C80.5693 53.9038 82.1256 49.8621 82.1256 45.1459C82.1256 40.6846 80.5292 36.7089 77.3812 33.3293C74.61 30.3545 71.1532 28.4597 67.0889 27.6836ZM75.0195 54.8197C72.5592 57.429 69.5419 58.6975 65.7944 58.6975C61.5538 58.6975 57.9675 57.0053 54.8306 53.524C51.6468 49.9909 50.0992 45.807 50.0992 40.7327C50.0992 32.9381 52.3045 25.9008 56.6529 19.8165C60.802 14.012 67.0243 8.88709 75.163 4.56756L78.3576 10.6205C68.5532 15.7975 63.5853 22.0198 63.5853 29.1328V30.6523L65.0945 30.8265C69.0866 31.2873 72.2893 32.8662 74.8862 35.6537C77.4632 38.4201 78.7157 41.525 78.7157 45.146C78.7158 49.0173 77.5067 52.1818 75.0195 54.8197Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </div>
                                            <p>The entire process with Mystra Tech was refreshingly transparent. Their open communication and streamlined workflow made a complex project feel effortless. They are a truly reliable and professional team.</p>
                                            <div className="author__thumb">
                                                <div className="author__thumb-inner">
                                                    <img src="assets/img/brand/client-01.jpg" alt="mystra-about"/>
                                                </div>
                                            </div>
                                            <span className="author__name">Avenash</span>
                                            <span className="author__designation"> CEO, ArknEngineering Pvt Ltd</span>
                                        </div>
                                    </div>
                                    </SwiperSlide>  

                                     <SwiperSlide>
                                     <div className="swiper-slide">
                                        <div className="testimonial-box-2">
                                            <h4>Content Writing Project</h4>
                                            <div className="quote-icon">
                                                <svg viewBox="0 0 83 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M20.8162 27.6795C21.5404 22.1887 26.3942 17.2186 35.2725 12.8877L36.8713 12.1077L30.3167 0.00634766L28.837 0.756361C10.0619 10.2736 0.541992 23.7238 0.541992 40.7336C0.541992 46.6026 2.40503 51.6715 6.07972 55.7999C9.80594 59.9858 14.3279 62.1083 19.521 62.1083C24.1871 62.1083 28.1438 60.4467 31.2811 57.1692C34.3979 53.9127 35.9783 49.8679 35.9783 45.1469C35.9783 40.6858 34.3819 36.7101 31.2336 33.3303C28.4567 30.3491 24.9577 28.4527 20.8162 27.6795ZM28.8176 54.8112C26.3139 57.4268 23.273 58.6982 19.521 58.6982C15.2846 58.6982 11.7212 57.0084 8.62721 53.5325C5.48125 49.9984 3.95192 45.8119 3.95192 40.7335C3.95192 32.9375 6.1472 25.8991 10.4764 19.8141C14.6072 14.0084 20.8028 8.88265 28.907 4.56263L32.1907 10.6249C22.3151 15.8001 17.3114 22.0212 17.3114 29.1335V30.6564L18.8245 30.8277C22.9003 31.2891 26.1428 32.8679 28.7384 35.6544C31.3154 38.4209 32.5682 41.5262 32.5682 45.1467C32.5683 49.0132 31.3413 52.1743 28.8176 54.8112Z"
                                                        fill="#14CF93" />
                                                    <path
                                                        d="M67.0889 27.6836C67.8045 22.1883 72.6183 17.2157 81.4255 12.8842L82.9998 12.11L76.608 0L75.1136 0.754039C56.2526 10.2708 46.6895 23.7216 46.6895 40.7327C46.6895 46.6055 48.5763 51.6771 52.2974 55.8066C56.0649 59.9873 60.6055 62.1072 65.7944 62.1072C70.4663 62.1072 74.4048 60.4424 77.5004 57.1589C80.5693 53.9038 82.1256 49.8621 82.1256 45.1459C82.1256 40.6846 80.5292 36.7089 77.3812 33.3293C74.61 30.3545 71.1532 28.4597 67.0889 27.6836ZM75.0195 54.8197C72.5592 57.429 69.5419 58.6975 65.7944 58.6975C61.5538 58.6975 57.9675 57.0053 54.8306 53.524C51.6468 49.9909 50.0992 45.807 50.0992 40.7327C50.0992 32.9381 52.3045 25.9008 56.6529 19.8165C60.802 14.012 67.0243 8.88709 75.163 4.56756L78.3576 10.6205C68.5532 15.7975 63.5853 22.0198 63.5853 29.1328V30.6523L65.0945 30.8265C69.0866 31.2873 72.2893 32.8662 74.8862 35.6537C77.4632 38.4201 78.7157 41.525 78.7157 45.146C78.7158 49.0173 77.5067 52.1818 75.0195 54.8197Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </div>
                                            <p>Working with Mystra Tech was phenomenal. Their team’s dedication and transparency are unmatched. They didn’t just build a product; they became a vital part of our team.</p>
                                            <div className="author__thumb">
                                                <div className="author__thumb-inner">
                                                    <img src="assets/img/brand/client-02.jpg" alt="mystra-about"/>
                                                </div>
                                            </div>
                                            <span className="author__name">Krishna Kumar GM</span>
                                            <span className="author__designation">Sales Head, Indus Engineering</span>
                                        </div>
                                    </div>
                                    </SwiperSlide> 
                                   
                                    <SwiperSlide>
                                     <div className="swiper-slide">
                                        <div className="testimonial-box-2">
                                            <h4>Prototype Case Project</h4>
                                            <div className="quote-icon">
                                                <svg viewBox="0 0 83 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M20.8162 27.6795C21.5404 22.1887 26.3942 17.2186 35.2725 12.8877L36.8713 12.1077L30.3167 0.00634766L28.837 0.756361C10.0619 10.2736 0.541992 23.7238 0.541992 40.7336C0.541992 46.6026 2.40503 51.6715 6.07972 55.7999C9.80594 59.9858 14.3279 62.1083 19.521 62.1083C24.1871 62.1083 28.1438 60.4467 31.2811 57.1692C34.3979 53.9127 35.9783 49.8679 35.9783 45.1469C35.9783 40.6858 34.3819 36.7101 31.2336 33.3303C28.4567 30.3491 24.9577 28.4527 20.8162 27.6795ZM28.8176 54.8112C26.3139 57.4268 23.273 58.6982 19.521 58.6982C15.2846 58.6982 11.7212 57.0084 8.62721 53.5325C5.48125 49.9984 3.95192 45.8119 3.95192 40.7335C3.95192 32.9375 6.1472 25.8991 10.4764 19.8141C14.6072 14.0084 20.8028 8.88265 28.907 4.56263L32.1907 10.6249C22.3151 15.8001 17.3114 22.0212 17.3114 29.1335V30.6564L18.8245 30.8277C22.9003 31.2891 26.1428 32.8679 28.7384 35.6544C31.3154 38.4209 32.5682 41.5262 32.5682 45.1467C32.5683 49.0132 31.3413 52.1743 28.8176 54.8112Z"
                                                        fill="#14CF93" />
                                                    <path
                                                        d="M67.0889 27.6836C67.8045 22.1883 72.6183 17.2157 81.4255 12.8842L82.9998 12.11L76.608 0L75.1136 0.754039C56.2526 10.2708 46.6895 23.7216 46.6895 40.7327C46.6895 46.6055 48.5763 51.6771 52.2974 55.8066C56.0649 59.9873 60.6055 62.1072 65.7944 62.1072C70.4663 62.1072 74.4048 60.4424 77.5004 57.1589C80.5693 53.9038 82.1256 49.8621 82.1256 45.1459C82.1256 40.6846 80.5292 36.7089 77.3812 33.3293C74.61 30.3545 71.1532 28.4597 67.0889 27.6836ZM75.0195 54.8197C72.5592 57.429 69.5419 58.6975 65.7944 58.6975C61.5538 58.6975 57.9675 57.0053 54.8306 53.524C51.6468 49.9909 50.0992 45.807 50.0992 40.7327C50.0992 32.9381 52.3045 25.9008 56.6529 19.8165C60.802 14.012 67.0243 8.88709 75.163 4.56756L78.3576 10.6205C68.5532 15.7975 63.5853 22.0198 63.5853 29.1328V30.6523L65.0945 30.8265C69.0866 31.2873 72.2893 32.8662 74.8862 35.6537C77.4632 38.4201 78.7157 41.525 78.7157 45.146C78.7158 49.0173 77.5067 52.1818 75.0195 54.8197Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </div>
                                            <p>Mystra Tech's professional work ethic is fantastic. They understood our vision, communicated transparently, and delivered a robust platform that was absolutely critical for our launch and subsequent growth.</p>
                                            <div className="author__thumb">
                                                <div className="author__thumb-inner">
                                                    <img src="assets/img/brand/client-03.jpg" alt="mystra-about"/>
                                                </div>
                                            </div>
                                            <span className="author__name">Michael</span>
                                            <span className="author__designation">Head of Operations, Musterguard</span>
                                        </div>
                                    </div>
                                    </SwiperSlide>
                                  
                                   <SwiperSlide>
                                    <div className="swiper-slide">
                                        <div className="testimonial-box-2">
                                            <h4>Digital Marketing Project</h4>
                                            <div className="quote-icon">
                                                <svg viewBox="0 0 83 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M20.8162 27.6795C21.5404 22.1887 26.3942 17.2186 35.2725 12.8877L36.8713 12.1077L30.3167 0.00634766L28.837 0.756361C10.0619 10.2736 0.541992 23.7238 0.541992 40.7336C0.541992 46.6026 2.40503 51.6715 6.07972 55.7999C9.80594 59.9858 14.3279 62.1083 19.521 62.1083C24.1871 62.1083 28.1438 60.4467 31.2811 57.1692C34.3979 53.9127 35.9783 49.8679 35.9783 45.1469C35.9783 40.6858 34.3819 36.7101 31.2336 33.3303C28.4567 30.3491 24.9577 28.4527 20.8162 27.6795ZM28.8176 54.8112C26.3139 57.4268 23.273 58.6982 19.521 58.6982C15.2846 58.6982 11.7212 57.0084 8.62721 53.5325C5.48125 49.9984 3.95192 45.8119 3.95192 40.7335C3.95192 32.9375 6.1472 25.8991 10.4764 19.8141C14.6072 14.0084 20.8028 8.88265 28.907 4.56263L32.1907 10.6249C22.3151 15.8001 17.3114 22.0212 17.3114 29.1335V30.6564L18.8245 30.8277C22.9003 31.2891 26.1428 32.8679 28.7384 35.6544C31.3154 38.4209 32.5682 41.5262 32.5682 45.1467C32.5683 49.0132 31.3413 52.1743 28.8176 54.8112Z"
                                                        fill="#14CF93" />
                                                    <path
                                                        d="M67.0889 27.6836C67.8045 22.1883 72.6183 17.2157 81.4255 12.8842L82.9998 12.11L76.608 0L75.1136 0.754039C56.2526 10.2708 46.6895 23.7216 46.6895 40.7327C46.6895 46.6055 48.5763 51.6771 52.2974 55.8066C56.0649 59.9873 60.6055 62.1072 65.7944 62.1072C70.4663 62.1072 74.4048 60.4424 77.5004 57.1589C80.5693 53.9038 82.1256 49.8621 82.1256 45.1459C82.1256 40.6846 80.5292 36.7089 77.3812 33.3293C74.61 30.3545 71.1532 28.4597 67.0889 27.6836ZM75.0195 54.8197C72.5592 57.429 69.5419 58.6975 65.7944 58.6975C61.5538 58.6975 57.9675 57.0053 54.8306 53.524C51.6468 49.9909 50.0992 45.807 50.0992 40.7327C50.0992 32.9381 52.3045 25.9008 56.6529 19.8165C60.802 14.012 67.0243 8.88709 75.163 4.56756L78.3576 10.6205C68.5532 15.7975 63.5853 22.0198 63.5853 29.1328V30.6523L65.0945 30.8265C69.0866 31.2873 72.2893 32.8662 74.8862 35.6537C77.4632 38.4201 78.7157 41.525 78.7157 45.146C78.7158 49.0173 77.5067 52.1818 75.0195 54.8197Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </div>
                                             <p>Mystra Tech’s commitment is top-notch. Their team’s incredible work ethic and dedication were evident at every stage, delivering results that exceeded our expectations. A fantastic technology partner.</p>
                                            <div className="author__thumb">
                                                <div className="author__thumb-inner">
                                                    <img src="assets/img/brand/client-04.jpg" alt="mystra-about"/>
                                                </div>
                                            </div>
                                            <span className="author__name">Jeffin</span>
                                            <span className="author__designation">Founder, Pints</span>
                                        </div>
                                    </div>
                                   </SwiperSlide>
                                </Swiper>
                                   
                                </div>
                            </div>
                            <div className="testimonial-slider-2-navigation slider-nav-wrapper">
                                <button className="testimonial-slider-2-button-prev slider-nav slider-nav-prev"><i
                                        className="fa-regular fa-arrow-left-long"></i></button>
                                <button className="testimonial-slider-2-button-next slider-nav slider-nav-next"><i
                                        className="fa-regular fa-arrow-right-long"></i></button>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- testimonial area end  --> */}


              
                {/* <!-- image-area start --> */}
                {/* <div className="image-thumb-area parallax-container">
                    <div className="parallax-image" data-background="assets/img/gallery/gallery-1.jpg" style={{backgroundImage: "url(assets/img/gallery/gallery-1.jpg)"}}></div>
                </div> */}
                {/* <!-- image-area end --> */}

                {/* <!-- scroll layout start --> */}
                <div className="scroll-layout pt-105 pb-105">
                    <section className="link-scroll-area pb-35 p-relative fix">
                        <div className="swiper text__scroll">
                            <div className="swiper-wrapper link-scroll-wrapper">
                           <Swiper
                              direction="horizontal"
                                loop={true}
                             speed={20000}
                                autoplay={{
                                    delay: 0,
                                    // reverseDirection: true, // ← scrolls right-to-left
                                    disableOnInteraction: false,
                                }}
                                slidesPerView="auto"
                                modules={[Autoplay]}
                                >

                                <SwiperSlide>
                                <div className="swiper-slide">
                                    <div className="link-scroll-line">
                                        <h2 className="link-scroll-line__heading xlarge uppercase">
                                             &nbsp;<a href="/mystra-service">Social Media Marketing</a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span> 
   &nbsp;<a href="/mystra-service">SEO </a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span>
   &nbsp;<a href="/mystra-service">SEM </a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span>
                                        </h2>
                                    </div>
                                </div>

                                </SwiperSlide>
                                                                <SwiperSlide>

                                        <div className="swiper-slide">
                                            <div className="link-scroll-line">
                                                <h2 className="link-scroll-line__heading xlarge uppercase">
                                    
                                           
   &nbsp;<a href="/mystra-service">Content Creation & Production </a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span>
   &nbsp;<a href="/mystra-service">Web Development </a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span>
   &nbsp;<a href="/mystra-service">App Development </a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span>
   &nbsp;<a href="/mystra-service">AI Agents </a>&nbsp;
   <span className="link-separate-icon">
                                                <svg width="500" height="500" viewBox="0 0 500 500" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M100.999 250L0 190.598L74.4421 59.402L175.5 118.701L175.557 0H324.443L324.5 118.701L425.557 59.402L500 190.598L399 250L500 309.402L425.557 440.598L324.5 381.299L324.443 500H175.557L175.5 381.299L74.4421 440.598L0 309.402L100.999 250Z"
                                                        fill="#14CF93" />
                                                </svg>
                                            </span>
                                                </h2>
                                            </div>
                                        </div>
                                </SwiperSlide>

                                </Swiper>

                                

                                
                            </div>
                        </div>
                    </section>
                    
                </div>
                {/* <!-- scroll layout end --> */}

                {/* <!-- team area start --> */}
                <section className="team-area fix section-spacing-bottom">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xxl-10">
                                <div className="team-section-3">
                                    <div className="section__title-wrapper tpl__item-center mb-60">
                                        <span className="section__inner-subtitle">Our Awesome Team</span>
                                        <h2 className="section__title-inner title-anim">We're a fully remote team of around&nbsp;
                                            <span className="section-title-hightlight">20 creative professionals</span>&nbsp;
                                            spread out across the bangalore
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ref={layoutRef}>
                           <div className="team-thumb-wrapper p-relative">
                        <div className="team-thumb-3-1">
                            <img className="topylo-tilt" src="assets/img/gallery/gallery-6.jpg" alt="mystra-about"/>
                        </div>
                        <div className="team-thumb-3-2 team-3-thum-common-2">
                            <img className="topylo-tilt" src="assets/img/gallery/gallery-5.jpg" alt="mystra-about"/>
                        </div>
                        <div className="container">
                            <div className="team-thum-grid-top">
                                <div className="team-thumb-3-3 team-3-thum-common">
                                    <img className="topylo-tilt" src="assets/img/gallery/gallery-3.jpg"
                                        alt="mystra-about"/>
                                </div>
                                <div className="team-thumb-3-4 team-3-thum-common-2">
                                    <img className="topylo-tilt" src="assets/img/gallery/gallery-4.jpg"
                                        alt="mystra-about"/>
                                </div>
                                <div className="team-thumb-3-5 team-3-thum-common">
                                    <img className="topylo-tilt" src="assets/img/gallery/gallery-2.jpg"
                                        alt="mystra-about"/>
                                </div>
                            </div>
                            <div className="team-middle">
                                <div className="area-btn">
                                    <a className="c-button is-fill" href="/mystra-contact" >
                                        <span className="c-button__border"></span>
                                        <span className="c-button__text">Join With us</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="team-thumb-grid-bottom">
                        <div className="team-thumb-3-6">
                            <img className="topylo-tilt" src="assets/img/gallery/gallery-7.jpg" alt="mystra-about"/>
                        </div>
                        <div className="team-thumb-3-7 team-3-thum-common">
                            <img className="topylo-tilt" src="assets/img/gallery/gallery-5.jpg" alt="mystra-about"/>
                        </div>
                        <div className="team-thumb-3-8">
                            <img className="topylo-tilt" src="assets/img/gallery/gallery-8.jpg" alt="mystra-about"/>
                        </div>
                    </div>
                    </div>
                </section>
                {/* <!-- team area end --> */}

                 {/* <!-- blog area start  --> */}
                <section className="blogpost-area section-spacing p-relative fix">
                    <div className="blogpost-area__overlay area-absolute"></div>
                    <div className="noise-wrapper">
                        <div className="noise"></div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section__title-wrapper">
                                    <div className="section__subtitle tpl__item-center">
                                       
                                        <p className="section__subtitle-text">
                                           <img src="assets/img/shapes/section-title-star.png" alt="section-title-star.png"/> Our Working Process
                                        </p>
                                    </div>
                                    <h2 className="section__title-main xlarge uppercase tpl__item-center title-anim">
                                       How We Bring Ideas Alive</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-center">
                            <div className="col-lg-12">
                                <div className="blog__list">
                                    <div className="blog__item-1">
                                        <div className="">
                                            <a href="/mystra-service" className="tag">Analysis</a>
                                            <h3 className="blog__item-1-title title-block-2">
                                                    We research to understand user needs, informing design and development decisions to drive engagement and conversions

                                            </h3>
                                            {/* <div className="blog__meta-list">
                                                <div className="meta-item">
                                                    <p>May 26, 2025</p>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div
                                            className="blog__button btn_wrapper d-flex align-items-center justify-content-end">
                                            <a className="c-button btn-moving" href="/mystra-contact">
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text"><i className="flaticon-right-arrow"></i></span>
                                            </a>
                                        </div>
                                        <img className="blog-thumb-hover d-none d-md-block hover-img"
                                            src="assets/img/about/ABOUT/Analysis.webp" alt="mystra-about"/>
                                    </div>
                                    <div className="blog__item-1">
                                        <div className="">
                                            <a href="/mystra-service" className="tag">Research</a>
                                            <h3 className="blog__item-1-title title-block-2">
                                               Live workshop where we define the main problems and challenges before
                                            building a strategic plan moving forward.
                                            </h3>
                                        </div>
                                        <div
                                            className="blog__button btn_wrapper d-flex align-items-center justify-content-end">
                                            <a className="c-button btn-moving" href="/mystra-contact">
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text"><i className="flaticon-right-arrow"></i></span>
                                            </a>
                                        </div>
                                        <img className="blog-thumb-hover d-none d-md-block"
                                            src="assets/img/about/ABOUT/research.webp" alt="mystra-about"/>
                                    </div>
                                    <div className="blog__item-1">
                                        <div className="">
                                            <a href="/mystra-service" className="tag">Design</a>
                                            <h3 className="blog__item-1-title title-block-2">
                                                Our design expertise creates visually stunning, user-centered designs that captivate audiences and drive conversions.
                                            </h3>
                                        </div>
                                        <div
                                            className="blog__button btn_wrapper d-flex align-items-center justify-content-end">
                                            <a className="c-button btn-moving" href="/mystra-contact">
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text"><i className="flaticon-right-arrow"></i></span>
                                            </a>
                                        </div>
                                        <img className="blog-thumb-hover d-none d-md-block"
                                            src="assets/img/about/ABOUT/Design.webp" alt="mystra-about"/>
                                    </div>

                                     <div className="blog__item-1">
                                        <div className="">
                                            <a href="/mystra-service" className="tag">Development</a>
                                            <h3 className="blog__item-1-title title-block-2">
                                              Our team builds scalable, robust, and secure solutions using cutting-edge technologies to drive business growth and deliver seamless user experiences.
                                            </h3>
                                        </div>
                                        <div
                                            className="blog__button btn_wrapper d-flex align-items-center justify-content-end">
                                            <a className="c-button btn-moving" href="/mystra-contact">
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text"><i className="flaticon-right-arrow"></i></span>
                                            </a>
                                        </div>
                                        <img className="blog-thumb-hover d-none d-md-block"
                                            src="assets/img/about/ABOUT/Development.webp" alt="mystra-about"/>
                                    </div>


                                     <div className="blog__item-1">
                                        <div className="">
                                            <a href="/mystra-service" className="tag">Onboarding</a>
                                            <h3 className="blog__item-1-title title-block-2">
                                               Our onboarding process provides personalized support and training for a smooth transition, minimizing downtime and maximizing ROI.
                                            </h3>
                                        </div>
                                        <div
                                            className="blog__button btn_wrapper d-flex align-items-center justify-content-end">
                                            <a className="c-button btn-moving" href="/mystra-contact">
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text"><i className="flaticon-right-arrow"></i></span>
                                            </a>
                                        </div>
                                        <img className="blog-thumb-hover d-none d-md-block"
                                            src="assets/img/about/ABOUT/Onboarding.webp" alt="mystra-about"/>
                                    </div>


                                      <div className="blog__item-1">
                                        <div className="">
                                            <a href="/mystra-service" className="tag">Support</a>
                                            <h3 className="blog__item-1-title title-block-2">
                                              
                                               Mystra's dedicated support team provides proactive maintenance and responsive assistance to ensure optimal performance and business success.
                                            </h3>
                                        </div>
                                        <div
                                            className="blog__button btn_wrapper d-flex align-items-center justify-content-end">
                                            <a className="c-button btn-moving" href="/mystra-contact">
                                                <span className="c-button__border"></span>
                                                <span className="c-button__text"><i className="flaticon-right-arrow"></i></span>
                                            </a>
                                        </div>
                                        <img className="blog-thumb-hover d-none d-md-block"
                                            src="assets/img/about/ABOUT/Support.webp" alt="mystra-about"/>
                                    </div>

                                    <div className="blog-img-wrap">
                                        <div className="blog-img"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- blog area end  --> */}

    {/* <!-- discuss area start  --> */}
    <section className="discuss-area section-spacing p-relative">
        <div className="discuss-area__bg area-absolute" data-background="assets/img/about/6-works-min.png"  style={{backgroundImage: "url(assets/img/about/6-works-min.png"}}>
            <div className="noise-wrapper">
                <div className="noise"></div>
            </div>
        </div>
        <div className="container">
            <div className="discuss__content-wrapper">
                <div className="row align-items-center g-5">
                    <div className="col-lg-9">
                        <div className="section__title-3-wrapper section__title-wrapper-discuss">
                            <div className="section__subtitle-3">
                                <p className="section__subtitle-text">
                                    You dream it. We code it.
                                </p>
                                {/* <!-- <div className="section__subtitle-number"> */}
                                    {/* <span>09</span>
                                </div> --> */}
                            </div>
                            <h2 className="section__title-main xlarge uppercase folks-text">Let’s Build the Unignorable</h2>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="area-btn d-flex justify-content-lg-end">
                            <a href="/mystra-contact" className="circle-btn discuss__btn">
                                <span className="icon-box" data-background="assets/img/about/7-last-min.png">
                                    <i className="flaticon-paper-plane"></i>
                                </span>
                                <img src="assets/img/icons/send-message-text.png" alt="mystra-about"
                                    className="image-text"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- discuss area end  --> */}
            </main>

            <Footer/>
        </div>

    </div>

    {/* <!-- back to top start --> */}
    <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    {/* <!-- back to top end --> */}
      </main>
)}

export default About;
